import { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import TableRow from "@mui/material/TableRow";

import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
// Acromegaly React components
import MDBox from "components/MDBox";

import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { styled } from "@mui/material/styles";
// Acromegaly React contexts
import { useMaterialUIController } from "context";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextField,
  Tooltip,
} from "@mui/material";
import getText from "Translator";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { displayErrorMessage } from "controllers/validation";

import { displaySuccessMessage } from "controllers/validation";
import { getAllQuestions } from "controllers/QuestionController";
import { addQuestionToPage } from "controllers/QuestionController";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  td: {
    height: 42,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function AllQuestions(props) {
  const [controller] = useMaterialUIController();
  const [loading, setLoading] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [search, setSearch] = useState("");
  const [datas, setDatas] = useState([]);

  const {
    rownumber,
    page,
    capsule,
    getPageQuestionsDatas,
    handleAddQuestionToReport,
    handleAddQuestionToCoditionReport,
  } = props;

  const navigate = useNavigate();

  useEffect(() => {
    console.log("newData");
    if (!controller.authenticated) {
      navigate("/authentication/sign-in", { replace: true });
      return;
    }

    getData("");
  }, []);
  const getData = async (searchx) => {
    try {
      setLoading(true);
      let newData = {
        rowsPerPage: rowsPerPage,
        page: 1,
        search: searchx,
        lang: controller.lang,
      };
      console.log(newData);
      let data = await getAllQuestions(
        controller.lang,
        newData,
        controller.token
      );
      console.log(newData, data);
      setLoading(false);
      if (data.success) {
        setDatas(data.data);
      } else {
        displayErrorMessage(controller.lang, data.message);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  const handleAddQuestion = async (id) => {
    //
    try {
      setLoading(true);
      let newData = {
        rownumber,
        page,
        lang: controller.lang,
        question: id,
        capsule,
      };
      let data = await addQuestionToPage(
        controller.lang,
        newData,
        controller.token
      );
      setLoading(false);
      if (data.success) {
        getPageQuestionsDatas();
        displaySuccessMessage(controller.lang, data.message);
      } else {
        displayErrorMessage(controller.lang, data.message);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  return (
    <LoadingOverlay
      active={loading}
      spinner
      text={getText("loading", controller.lang)}
    >
      <TableContainer style={{ maxHeight: 600 }}>
        <Table size="small">
          <TableBody>
            <TableRow style={{ backgroundColor: "#ccc" }}>
              <TableCell colSpan={2}>
                <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                  <OutlinedInput
                    id="outlined-adornment-search"
                    fullWidth
                    placeholder={getText("search", controller.lang)}
                    onChange={(event) => {
                      setSearch(event.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key == "Enter") {
                        getData(e.target.value);
                      }
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            getData(search);
                          }}
                          onMouseDown={() => {
                            getData(search);
                          }}
                          edge="end"
                        >
                          <SearchOutlinedIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </TableCell>
            </TableRow>

            {datas.map((row, index) => (
              <StyledTableRow
                key={row.name}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#f2f2f2",
                  cursor: "copy",
                }}
                onClick={() => {
                  if (handleAddQuestionToReport) {
                    handleAddQuestionToReport(row._id, row.questiond.text);
                    return;
                  }
                  if (handleAddQuestionToCoditionReport) {
                    handleAddQuestionToCoditionReport(
                      row._id,
                      row.questiond.text
                    );
                    return;
                  }
                  if (!handleAddQuestionToReport) {
                    handleAddQuestion(row._id);
                  }
                }}
              >
                <TableCell
                  style={{
                    paddingStart: 5,
                  }}
                >
                  {row.questiond.text}
                </TableCell>
                <TableCell align="center">
                  <Tooltip
                    title={getText("questionfromlist", controller.lang)}
                    aria-label="edit"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <AddCircleOutlineIcon
                      style={{ width: 20, height: 20 }}
                      color="secondary"
                      onClick={() => {
                        if (handleAddQuestionToReport) {
                          handleAddQuestionToReport(
                            row._id,
                            row.questiond.text
                          );
                          return;
                        }
                        if (handleAddQuestionToCoditionReport) {
                          handleAddQuestionToCoditionReport(
                            row._id,
                            row.questiond.text
                          );
                          return;
                        }
                        if (!handleAddQuestionToReport) {
                          handleAddQuestion(row._id);
                        }
                      }}
                    />
                  </Tooltip>
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </LoadingOverlay>
  );
}

export default AllQuestions;
